import { Col, Row, Space, Typography } from "antd";
import Banner from "../Banner";
import RealStateListItems from "./Components/ListItems";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import TopFilters from "./Components/TopFilterOptions";
import { FC, useEffect } from "react";
import { useGetUserAdverts } from "./ServerSideStates";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";

interface PortfolioIndexProps {
  isMLS?: boolean;
}
const PortfolioIndex: FC<PortfolioIndexProps> = ({ isMLS = true }) => {
  const { Text } = Typography;
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const { filter } = useSelector((state: RootState) => state.portofolio);
  const adverts = useGetUserAdverts(filter);
  console.log("advertsadverts",filter)
  return (
    <>
      <Col xs={24} className="!p-0">
        <Row
          gutter={[
            { xs: 10, md: 10, xl: 10 },
            { xs: 0, md: 15, xl: 20 }
          ]}

          className="">
          {isMLS && (
            <>
              <Col xs={24}>
                <Banner />
              </Col>
            </>
          )}
          <Col span={24} className=" justify-center !hidden lg:!flex">

            <Text className="">

              <Helmet>
                <title className="capitalize">{"İlanlarım"}</title>
              </Helmet>
              <Space>
                <span className="!text-lg md:!text-2xl !font-bold">
                  {userInfoes?.isIndividual ? "Portföyüm" : "İlanlarım"}
                </span>
                <span className="!text-gray-400">
                  ({adverts?.data?.data?.filteredCount || "0"})
                </span>
              </Space>
            </Text>
          </Col>
          {!isMLS && (
            <>
              <Col xs={24}>
                <TopFilters />
              </Col>
            </>
          )}

          <Col xs={24} className="">
            <RealStateListItems />
          </Col>
        </Row>
      </Col>
      <></>
    </>
  );
};

export default PortfolioIndex;
